<template>
  <td>
    <h6 class="custom-margin-h6-table">
      <strong>{{ $t('common_words.packing_houses') }}:</strong>
    </h6>
    <span v-if="packing_houses">
      <span v-for="(_, valueKey) in packing_houses" :key="valueKey">
        <el-tag type="info" style="height: auto; width: 48%;"
          >{{ $t('common_words.code') }}:
          {{ infoData.code_packing_houses[valueKey] }}<br />
          {{ $t('common_words.name') }}:
          {{ infoData.name_packing_houses[valueKey] }}<br />
          {{ $t('common_words.allotment(s)') }}:
          {{ infoData.lots_packing_houses[valueKey].join(', ') }}
        </el-tag>
      </span>
    </span>
    <el-tag v-else type="warning" effect="dark" class="mt-2">{{
      $t('common_words.no_assignment')
    }}</el-tag>
  </td>
</template>
<script>
export default {
  name: 'td-info-packing-houses',
  props: {
    packing_houses: {
      required: true,
    },
    infoData: {
      type: Object,
      required: true,
    },
  },
};
</script>
